<template>
  <v-card class="pa-4">
    <h3 class="text-center">Customizar Etiqueta</h3>
    <p class="text-center">{{ $t('Layout da Etiqueta') }}:</p>

    <div class="d-flex justify-center">
      <v-file-input
        id="qr-code-image"
        block
        class="d-none"
        @change="changeQrCodeInstImage"
      ></v-file-input>

      <v-btn
        class="ma-1 mt-4 primary-button"
        text
        block
        v-if="!logo"
        @click="openChangeLogo"
      >
        {{ $t('Alterar logo') }}
      </v-btn>

      <v-btn
        class="ma-1 mt-4 primary-button"
        block
        text
        v-if="logo"
        @click="logo = null"
      >
        {{ $t('Usar imagem da instituição') }}
      </v-btn>
    </div>

    <v-card
      outlined
      class="pa-4 ma-2 text-center"
      height="100%"
      style="break-inside: avoid"
    >
      <img
        class="mt-4 mb-2"
        :src="
          logo
            ? logo
            : institution && institution.logoPath
            ? institution.logoPath
            : require('../../../../../assets/01_-_Reduzido_Cor.png')
        "
        alt="Equipacare"
        style="width: 6rem; border-radius: 8px"
      />

      <div class="my-1">
        <strong>Setor:</strong>
        <span> Laboratório </span>
      </div>

      <div class="my-1 mb-4">
        <strong>Sub-setor:</strong>
        <span> Sub-Laboratório </span>
      </div>

      <Qrcode :value="`${value}ABCD-EFGH`" :size="100"></Qrcode>
    </v-card>

    <v-card-actions class="px-0">
      <v-btn outlined class="primary-button" @click="$emit('close')">
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :loading="loading"
        class="ma-1 secondary-button"
        text
        @click="saveTagCustomization"
      >
        {{ $t('Salvar Etiqueta') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.tag {
  display: flex;
  border: 1px solid black;
  margin: 5px;
  padding-top: 0;
  justify-content: center;
}

@media print {
  header {
    display: none;
  }

  .tag {
    max-width: 40% !important;
  }

  .row {
    margin-top: 5rem;
  }
}
</style>

<script>
import ApiService from '../../../../../services/ApiService'
import Qrcode from 'qrcode.vue'

export default {
  name: 'CustomizeQR',

  components: {
    Qrcode,
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.apiService
      .get(`institution/${this.institution.id}`)
      .then((response) => {
        this.institution = response.content

        this.layout = this.institution.qrCodeSectorCustomization
          ? JSON.parse(this.institution.qrCodeSectorCustomization)
          : this.layout

        this.logo = this.layout.logo
      })
  },

  data: () => ({
    institution: {},
    value: '1234-',
    apiService: new ApiService(),
    logo: '',
    layout: {
      logo: '',
      usingIdentificationLayout: true,
    },
    headMenu: null,
    loading: false,
  }),

  methods: {
    openChangeLogo() {
      const input = document.getElementById('qr-code-image')
      input.click()
    },

    changeQrCodeInstImage(image) {
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = (readerEvt) => {
        this.logo = readerEvt.target.result
      }
      reader.onerror = () => this.$toast.error('Ocorreu um erro!')
    },

    async saveTagCustomization() {
      this.layout.logo = this.logo

      const model = {
        customizationInJson: JSON.stringify(this.layout),
        institutionId: this.institution.id,
      }

      this.loading = true
      await this.apiService
        .post('institution/custom-sector-qrcode-tag', model)
        .then((response) => {
          this.$toast.success(response.message)
          this.loading = false
          this.institution.qrCodeTagCustomization = JSON.stringify(this.layout)

          localStorage.removeItem('institution')
          localStorage.setItem('institution', JSON.stringify(this.institution))

          this.$emit('close')
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
